import { getSourceInfo } from '@util'
import { Modal } from 'hljd'

export class CheckImg {
  constructor() {
    /**
     * 维护校验命中的图片数组，name：图片类型名称 list：图片列表 type：图片类型value
     *
     */
    this.initList = [
      { name: '头图', list: [], type: 1, mode: 'single' },
      { name: '封面图', list: [], type: 2, mode: 'single' },
      { name: '详情图', list: [], type: 3, mode: 'multiple' }
    ]
  }

  /**
   * 上传图片完成后调用
   * 校验图片颜色模式是否是rgb
   * type： 图片类型value path：七牛图片地址
   */
  checkCMYK = async (type, path) => {
    if (!path) {
      return
    }
    const data = await getSourceInfo(path)
    if (!data) {
      return
    }
    const reg = /(cmyk|CMYK)/

    if (reg.test(data.colorModel)) {
      this.initList.forEach(item => {
        if (item.type === type) {
          let _list = [...item.list]
          if (item.mode === 'single') {
            _list = [path]
          } else {
            _list.push(path)
          }
          item.list = _list
        }
      })
    }
  }

  /**
   * 编辑图片，需要重新整理校验过的图片列表
   * 删除图片，path参数传空
   */
  editImage = (type, path, oldPath) => {
    if (path) {
      this.checkCMYK(type, path)
    }

    this.initList.forEach(item => {
      if (item.type === type) {
        const idx = item.list.findIndex(item => item === oldPath)
        if (idx !== -1) {
          item.list.splice(idx, 1)
        }
      }
    })
  }

  /**
   * 提交方法开始时调用，弹窗是否存在非rgb的图片
   * types: arr 需要校验类型列表
   *
   */
  beforeAction = ({ types }) => {
    return new Promise((resolve, reject) => {
      const names = this.initList
        .map(item => {
          if (types.includes(item.type) && item.list.length > 0) {
            return item.name
          }
          return ''
        })
        .filter(item => item)

      if (names.length) {
        Modal.confirm({
          title: `检测到${names.join(
            '、'
          )}中存在非RGB色彩模式图片，这类图片在用户端APP展示会存在较大色差，是否确定发布？`,
          onOk: () => {
            this.initList.forEach(item => (item.list = []))
            resolve(true)
          },
          onCancel: () => resolve(false)
        })
      } else {
        resolve(true)
      }
    })
  }
}

export default CheckImg
